import React from "react";
import HomeIcon from "@mui/icons-material/Home";
import SportsSoccerIcon from "@mui/icons-material/SportsSoccer";
import TableViewIcon from "@mui/icons-material/TableView";
import EmojiEventsIcon from "@mui/icons-material/EmojiEvents";
import ViewInArIcon from "@mui/icons-material/ViewInAr";
import GroupIcon from "@mui/icons-material/Group";
import BadgeIcon from "@mui/icons-material/Badge";
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";
import FileUploadIcon from "@mui/icons-material/FileUpload";
import LocalAtmIcon from "@mui/icons-material/LocalAtm";
import MonetizationOnIcon from "@mui/icons-material/MonetizationOn";
import PaymentsIcon from "@mui/icons-material/Payments";
import ReceiptIcon from "@mui/icons-material/Receipt";
import SettingsIcon from "@mui/icons-material/Settings";
import ReportGmailerrorredIcon from "@mui/icons-material/ReportGmailerrorred";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import BusinessCenterIcon from '@mui/icons-material/BusinessCenter';
import LibraryBooksIcon from '@mui/icons-material/LibraryBooks';
import FeaturedVideoIcon from '@mui/icons-material/FeaturedVideo';

export const LeftSidebarData = [
  {
    icon: <BusinessCenterIcon sx={{ fontSize: 20 }} />,
    text: "Course",
    path: "/course",
  },
  {
    icon: <LibraryBooksIcon sx={{ fontSize: 20 }} />,
    text: "Chapter",
    path: "/chapter",
  },
  {
    icon: <FeaturedVideoIcon sx={{ fontSize: 20 }} />,
    text: "Video",
    path: "/video",
  },
];
